import foodRecipes_0 from "../../images/projects/foodRecipes/0.PNG";
import foodRecipes_1 from "../../images/projects/foodRecipes/1.PNG";
import foodRecipes_2 from "../../images/projects/foodRecipes/2.PNG";
import foodRecipes_3 from "../../images/projects/foodRecipes/3.PNG";
import foodRecipes_4 from "../../images/projects/foodRecipes/4.PNG";
import foodRecipes_5 from "../../images/projects/foodRecipes/5.PNG";
import foodRecipes_6 from "../../images/projects/foodRecipes/6.PNG";
import foodRecipes_7 from "../../images/projects/foodRecipes/7.PNG";
import foodRecipes_8 from "../../images/projects/foodRecipes/8.PNG";
import foodRecipes_9 from "../../images/projects/foodRecipes/9.PNG";
import foodRecipes_10 from "../../images/projects/foodRecipes/10.PNG";
import foodRecipes_11 from "../../images/projects/foodRecipes/11.PNG";

export default function foodRecipesImages() {
  return [
    foodRecipes_0,
    foodRecipes_1,
    foodRecipes_2,
    foodRecipes_3,
    foodRecipes_4,
    foodRecipes_5,
    foodRecipes_6,
    foodRecipes_7,
    foodRecipes_8,
    foodRecipes_9,
    foodRecipes_10,
    foodRecipes_11,
  ];
}
